module.exports = __webpack_public_path__ + "static/media/icon_close.4b279078.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_close.svg
// module id = 237
// module chunks = 0